import React from 'react'
import { Container, useMediaQuery, useTheme } from '@mui/material'
import Image7 from 'images/wholesale/007.svg'
import Image8 from 'images/wholesale/008.svg'
import Image9 from 'images/wholesale/009.svg'
import { useTranslation } from 'react-i18next'

const TITLE_COLOR = '#F0AE16'
const BUTTON_COLOR = '#F0AE16'

interface Feature {
  id: string
  title: string
  description: React.ReactElement | string
  image: string
}

interface ISpecialFeaturesSectionProps {}

const SpecialFeaturesSection: React.FC<ISpecialFeaturesSectionProps> = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down('md'))
  const backgroundColor = mdDown ? '#F2EEEA' : '#fff'

  const FEATURES: Feature[] = [
    {
      id: '1',
      title: t('wholesale.extraDiscounts', 'Extra Discounts'),
      description: t('wholesale.extraDiscountsDescription', 'You can qualify for a discount on bulk orders.'),
      image: Image7,
    },
    {
      id: '2',
      title: t('wholesale.customDesigns', 'Custom Designs'),
      description: t('wholesale.customDesignsDescription', 'We can make any design you can imagine. Just ask!'),
      image: Image8,
    },
    {
      id: '3',
      title: t('wholesale.afterPayment', 'After Payment'),
      description: t(
        'wholesale.afterPaymentDescription',
        'We’re running a special offer: 50% before, 50% after a month.'
      ),
      image: Image9,
    },
  ]

  return (
    <section style={{ backgroundColor }}>
      <div className='pb-20 md:pt-20 text-center'>
        <Container maxWidth='lg'>
          <h2
            className='sticky top-0 z-10 text-5xl md:text-6xl text-center py-10 font-semibold'
            style={{ backgroundColor }}
          >
            {t('wholesale.specialFeaturesForSpecialPartners', 'Special features for special partners')}
          </h2>
          <div className='flex flex-col md:flex-row mt-20'>
            {FEATURES.map(node => {
              return (
                <div key={node.id} className='md:w-1/3 bg-white my-10 md:m-0 rounded-2xl p-15 md:py-0'>
                  <img className='w-full h-180' src={node.image} alt={node.title} draggable={false} />
                  <h2 className='text-3xl md:text-4xl mb-20 mt-40 font-semibold' style={{ color: TITLE_COLOR }}>
                    {node.title}
                  </h2>
                  <p className='text-xl leading-normal'>{node.description}</p>
                </div>
              )
            })}
          </div>
        </Container>
      </div>
    </section>
  )
}

export default SpecialFeaturesSection
